<template>
  <div class="p-4">
    <!--    Title-->
    <h1 class="text-primary">
      Réussir le {{ examName }}
    </h1>
    <hr/>
    <!--    Lecon-->
    <div v-for="{key,title} in types" :key="key" v-show="getList(key).length">
      <h3>{{ title }}</h3>
      <div v-for="(l,index) in getList(key)" :key="l.id">
        <router-link :to="`/lecon/${niveau}/${l.id}`" class="text-secondary">
          {{ (index + 1) + '  - ' + l.titre }}
        </router-link>
      </div>
      <br/>
    </div>
  </div>
</template>

<script>
import {Lecons} from "@/js/caller";

export default {
  name : "lecon",
  props: ["niveau"],
  data() {
    return {
      list  : [],
      lecons: {},
      types : [
        {key: "gram", title: "Grammaire"},
        {key: "voc", title: "Vocabulaire"},
        {key: "other", title: "Autres Techniques"},
        {key: "gen", title: "Généralités"},
        {key: "pe", title: "Production écrite"},
        {key: "po", title: "Production orale"},
        {key: "edito", title: "L'éditorial"},
        {key: "rapport", title: "Le rapport"},
        {key: "article", title: "L'article"},
        {key: "theme", title: "Les thèmes"},
      ]
    }
  },
  computed: {
    examName() {
      return this.getExamName()
    }
  },
  watch   : {
    niveau() {
      this.getLecon();
    }
  },
  methods : {
    getExamName() {
      switch (this.niveau) {
        case "b1":
          return "DELF B1";
        case "b2":
          return "DELF B2";
        case "c1":
          return "DALF C1";
        case "c2":
          return "DALF C2";
        default:
          return ""
      }
    },
    getList(type) {
      return this.list
                 .filter(v => v.type === type)
                 .sort((a, b) => a.ordre - b.ordre)
    },
    getLecon() {
      const lecon = this.lecons[this.niveau];
      if (lecon) return this.list = lecon
      Lecons.List({
        Equal: [{field: "niveau", value: this.niveau}]
      }).then((res) => {
        this.lecons[this.niveau] = res;
        this.list = res;
      })
    }
  },
  mounted() {
    this.getLecon();
  }
}
</script>

<style scoped>

</style>